import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useMediaQuery } from "react-responsive";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import moment from "moment";

import { IoClose } from "react-icons/io5";

import { Header } from "../styled/common";
import { toast } from "react-toastify";

const StoreHeader = ({
  selectCompany,
  setSelectCompany,
  stores,
  openModal,
  closeModal,
  closeComponent,
  company,
  getCompany,
  currentAuth,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });

  const getTimeFormat = () => {
    return moment().format(
      isMobile ? "H시m분" : isTablet ? "a h시m분" : "YYYY년 MM월 DD일 A h시 m분",
    );
  };

  const [currentTime, setCurrentTime] = useState(getTimeFormat());

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    let animationFrameId;

    const updateCurrentTime = () => {
      setCurrentTime(getTimeFormat());
      animationFrameId = requestAnimationFrame(updateCurrentTime);
    };

    updateCurrentTime();
    return () => cancelAnimationFrame(animationFrameId);
  }, [isTablet, isMobile]);

  useEffect(() => {
    if (!selectCompany) return;
    setIsOpen(company?.isOpen);
  }, [selectCompany]);

  const changeStatus = () => {
    if (currentAuth === "VIEWER") {
      toast.error("변경 권한이 존재하지 않습니다.");
      return;
    }
    openModal({
      type: "confirmation",
      title: isOpen ? "영업종료" : "영업재개",
      message: [`영업을 ${isOpen ? "종료" : "재개"}하시겠습니까?`],
      handleConfirm: () => toggleOpen(),
      handleCancel: () => closeModal(),
    });
  };

  const toggleOpen = async () => {
    const url = "/erp/ss/company/upsert";
    const body = {
      input: { cmpnyNm: selectCompany.label, cmpnyNo: selectCompany?.value, isOpen: !isOpen },
    };

    try {
      const res = await axios.post(url, body);
      if (res.status) getCompany(selectCompany);
      setIsOpen(!isOpen);
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  const changeCompany = (cmpnyNo) => {
    const selecion = stores.find((ele) => String(ele.cmpnyNo) === String(cmpnyNo));
    if (!selecion) return;

    openModal({
      type: "confirmation",
      title: "회사 선택",
      message: [`${chooseParticle(selecion.cmpnyNm, "으로")}`, "회사를 변경하시겠습니까?"],
      handleConfirm: () => {
        const target = { label: selecion.cmpnyNm, value: selecion.cmpnyNo };

        setSelectCompany(target);
        sessionStorage.setItem("store", JSON.stringify(target));
        closeModal();
      },
      handleCancel: () => closeModal(),
    });
  };

  return (
    <>
      <Header>
        <div className="setting">
          <div className="company">
            <select value={selectCompany.value} onChange={(e) => changeCompany(e.target.value)}>
              {stores.map((ele) => (
                <option value={ele.cmpnyNo}>{ele.cmpnyNm}</option>
              ))}
            </select>
          </div>
          <div className="toggle">
            <label className={`switch ${isOpen ? "open" : "close"}`} onChange={changeStatus}>
              <input type="checkbox" checked={!isOpen} />
              <span className="slider"></span>
            </label>
            <span>{isOpen ? "영업중" : "영업종료"}</span>
          </div>
        </div>
        <div className="actions">
          <span>{currentTime}</span>
          <button className="close" onClick={closeComponent}>
            <IoClose />
          </button>
        </div>
      </Header>
    </>
  );
};

export default StoreHeader;
